type Props = {
    label: string;
};

/**
 * A yellow non-clickable tag used to highlight the "fiks ferdig" functionality.
 */

const Tag = ({ label }: Props) => (
    <div className="absolute text-14 font-bold text-yellow-900 bg-yellow-100 right-0 top-0 px-12 py-8 rounded-bl-8 hidden md:block">
        {label}
    </div>
);

export default Tag;
